<template>
  <ModalOperator class="no-border" type="primary" iconType="md-settings" iconSize="18" text="修改密码" title="修改密码">
    <zpa-form ref="Form">
      <zpa-form-group>
        <zpa-text-input
          label="用户名"
          v-model="data.userName"
          required
          readonly
        />
        <zpa-text-input
          label="登陆名"
          v-model="data.loginName"
          readonly
          required
        />
        <zpa-text-input
          label="旧密码"
          v-model="data.oldpassword"
          required
        />
        <zpa-text-input
          label="新密码"
          v-model="data.newpassword"
          :validators="[comparepwd]"
          validators-message="密码错误或过于简单"
          placeholder="至少八位,大小写+特殊字符@#$!%*?"
          required
        />
        <zpa-text-input
          label="新密码确认"
          v-model="data.newpasswordconf"
          :validators="[compare]"
          validators-message="与新密码不一致！"
          required
        />
      </zpa-form-group>
    </zpa-form>
  </ModalOperator>
</template>
<script>
import ModalOperatorMixin from '@/components/commons/ModalOperatorMixin'
import {getCurrentuser, changepwd, checkpwd, } from '@/api/login'
// import {changepwdEjy} from '@/api/fwsc/bank'
// import {
//   allowPush,
// } from '@/api/xmsb/register'

export default {
  name: 'ChangePwd',

  mixins: [
    ModalOperatorMixin,
  ],
  methods: {
    initialize() {
      this.data = {
        oldpassword: '',
        newpassword: '',
        newpasswordconf: '',
      }
    },
    async beforeOpen() {
      let _currentuser = await
      getCurrentuser()
      let _data = this.data
      this.data = {..._currentuser.userInfo,
        ..._data
      }
    },

    async beforeSubmit() {
      let _checkpwd = await
      checkpwd({password: this.data.oldpassword})
      let _this = this
      if (!_checkpwd) {
        _this.$Message.error('旧密码输入不正确！')
      }
      if(this.data.newpassword!=this.data.newpasswordconf){
        _this.$Message.error('新密码两次输入不一致')
        return false
      }
      let validPassw = this.comparepwd(this.data.newpassword)
      return this.$refs['Form'].validate() && _checkpwd && validPassw
    },

    onSubmit() {
      let _this = this
      /* allowPush().then(function (res) {
        if (res === true) {
          changepwd({..._this.data, newPassword: _this.data.newpassword, password: _this.data.oldpassword}).then(function (testData) {
            changepwdEjy({..._this.data, newPassword: _this.data.newpassword, password: _this.data.oldpassword
          })
            _this.$Message.success('修改成功！')
          },
          function (reason, testData) {
            _this.$Message.error('修改失败！')
          })
        } else { */
      changepwd({..._this.data, newPassword: _this.data.newpassword, password: _this.data.oldpassword}).then(function (testData) {
        _this.$Message.success('修改成功！')
      },
      function (reason, testData) {
        _this.$Message.error('修改失败！')
      })
      //   }
      // })
    },
    comparepwd(value){
      let zc = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$!%*?&])[A-Za-z\d@#$!%*?&]{8,}$/
      // if(!zc.test(value)){
      //   this.$Message.error('密码过于简单')
      // }
      return zc.test(value)
    },
    compare(value) {
      return value === this.data.newpassword
    }
  },
}
</script>
<style scoped>
.no-border.ivu-btn{
  border: 1px solid transparent;
}
</style>
